module.exports = __webpack_public_path__ + "img/usericon.b7d85385.svg";